export default __webpack_public_path__ + "static/media/cmm.bf8d5764.jpg";